import { render, staticRenderFns } from "./orderman_id.vue?vue&type=template&id=09f0051e&scoped=true"
import script from "./orderman_id.vue?vue&type=script&lang=js"
export * from "./orderman_id.vue?vue&type=script&lang=js"
import style0 from "./orderman_id.vue?vue&type=style&index=0&id=09f0051e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f0051e",
  null
  
)

export default component.exports